import template from './userCode.html';
import controller from './controller';

export default class LogModalService {
    static get $inject() {
        return ['$uibModal'];
    }

    constructor($uibModal) {
        this.$uibModal = $uibModal;
        this.modalInstace = null;
    }

    showUserCodeModal() {

        this.modalInstace = this.$uibModal.open({
            template: template,
            controller: controller,
            controllerAs: 'vm',
            size: 'lg',
        });
        return this.modalInstace;
    }

    close() {
        if (this.modalInstace) {
            this.modalInstace.close();
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/userCode/service.js
 **/